export const messages = {
  common: {
    phone: "+91 99999 00000",
    email: "info@abhayasriinfra.com",
    address: "Hyderabad, Telangana, India",
    fullAddress: "Abhayasri Infra Developers, Hyderabad, Telangana, India - 500001",
    companyName: "ABHAYASRI",
    companySubName: "Infra Developers",
    enquireNow: "Enquire Now",
    social: {
      instagram: "https://www.instagram.com/abhayasriinfra/",
      telegram: "https://t.me/abhayasriinfra",
      facebook: "https://www.facebook.com/abhayasriinfra/",
      whatsapp: "https://wa.me/919999900000"
    }
  },
  nav: { 
    home: "Home",
    about: "About",
    highlights: "Highlights",
    amenities: "Amenities",
    gallery: "Gallery",
    faq: "FAQ",
    projects: "Projects",
    location: "Location",
    contact: "Contact",
  },
  projects: {
    badge: "Our Projects",
    titlePart1: "Explore Our",
    titlePart2: "Landmark Developments",
    items: [
      {
        id: "elite-county",
        name: "ELITE COUNTY",
        location: "VANGAPALLI @ YADADRI BHONGIR DIST",
        tagline: "The Foundation of Tomorrow Laid Today",
        description: "DTCP & TG RERA Approved Layout. T.L.P. NO 39/2025/HRO/H1. Premium villa plots with modern amenities and excellent connectivity.",
        image: "/images/hero.jpeg",
        brochure: "/brochures/elite-county.pdf"
      },
      {
        id: "rukmini-enclave",
        name: "RUKMINI ENCLAVE",
        location: "ATMAKUR VILLAGE",
        tagline: "A Perfect Opportunity, A Perfect Location",
        description: "DTCP Approved Layout. T L P No. 157/2024/HV/DTCPO. TG RERA Approved. Premium villa plots in a serene and fast-developing location.",
        image: "/images/rukmini.jpeg",
        brochure: "/brochures/rukmini-enclave.pdf"
      }
    ]
  },
  hero: {
    titlePrefix: "Invest in Your",
    titleMiddle: "Future: Premium",
    titleHighlight: "Villa Plots",
    titleSuffix: "at Elite",
    titleCounty: "County",
    description: "Experience luxury living with elite connectivity and world-class infrastructure in the heart of the fastest-growing investment zone.",
    formTitle: "Get Exclusive Pricing & Brochure",
    formSubtitle: "Fill in your details for immediate access.",
    fullNamePlaceholder: "Full Name",
    phoneNumberPlaceholder: "Phone Number",
    ctaButton: "Get Offer Details",
    bookSiteVisit: "Book Site Visit",
    downloadBrochure: "Download Brochure",
  },
  highlights: {
    badge: "Location Advantage",
    titlePart1: "Project",
    titlePart2: "Highlights",
    description: "Strategically located for maximum appreciation and premium lifestyle convenience.",
    items: [
      { title: '5 Mins to NH-65', desc: 'Swift and direct access to the Hyderabad-Mumbai Highway (NH 65) for seamless connectivity.' },
      { title: 'Near Proposed RRR', desc: 'Located strategically in the vicinity of the Regional Ring Road for immense future appreciation.' },
      { title: 'Proximity to Hubs', desc: 'Close to MRF, PEBS Pennar & Prince Pipes, making it an ideal choice for professionals.' },
      { title: '15 Mins to IIT', desc: 'Short drive to IIT Hyderabad and other prestigious educational institutions in the vicinity.' },
      { title: 'Woxsen University', desc: 'Only 15 minutes away from the globally acclaimed Woxsen Business School campus.' },
      { title: '30 Mins to ORR', desc: 'Easy connectivity to the Outer Ring Road, linking you to the entire city of Hyderabad.' }
    ]
  },
  about: {
    badge: "About Our Company",
    titlePart1: "Building Trusts Through",
    titlePart2: "Quality & Excellence",
    p1: "At Abhayasri Infra Developers, our journey is guided by a clear vision — to create spaces that combine quality construction, thoughtful design, and long-term value. We believe real estate is about building trust and communities that last for generations.",
    p2: "With a strong focus on transparency, ethical practices, and customer satisfaction, every project we develop reflects our commitment to excellence. From land acquisition to final handover, we ensure careful planning at every stage.",
    stats: [
      { label: "Years Experience", value: "15+" },
      { label: "Happy Families", value: "500+" }
    ]
  },
  amenities: {
    badge: "World Class Features",
    titlePart1: "Modern",
    titlePart2: "Amenities",
    description: "Premium features designed specifically for a sophisticated, secure, and comfortable lifestyle.",
    items: [
      { title: 'Grand Entrance Gate', hoverText: 'Stunning architectural entrance providing a regal welcome to residents.' },
      { title: 'DTCP Approved', hoverText: 'Fully compliant with government regulations for complete peace of mind.' },
      { title: 'Modern Street Lights', hoverText: 'LED powered street lighting across the layout for safety and aesthetics.' },
      { title: 'Children Play Area', hoverText: 'Dedicated safe zones for kids to play and enjoy the outdoors.' },
      { title: '24/7 Security', hoverText: 'Round-the-clock gated security with CCTV surveillance for your family.' },
      { title: 'Landscaped Parks', hoverText: 'Beautifully designed green spaces to rejuvenate and connect with nature.' }
    ]
  },
  whyInvest: {
    titlePart1: "Why Invest with",
    titlePart2: "Abhayasri?",
    subtitle: "Built on trust, delivered with quality.",
    items: [
      {
        title: "DTCP & TG RERA Approved",
        description: "100% clear titles and legally compliant projects for your peace of mind."
      },
      {
        title: "Strategic Locations",
        description: "Carefully selected growth corridors ensuring high ROI and appreciation."
      },
      {
        title: "World-class Infrastructure",
        description: "40' & 33' wide BT roads, underground drainage, and designer landscaping."
      }
    ]
  },
  chairman: {
    badge: "Leadership Message",
    titlePart1: "A Vision for",
    titlePart2: "Modern Living",
    quote: '"At Abhayasri Infra, our vision is built on the bedrock of trust, quality, and an unwavering commitment to creating landmark developments that redefine luxury living."',
    p1: "We believe that a home is more than just a structure; it's a legacy. With 'Elite County', we are not just selling plots; we are offering an opportunity to be part of a future-ready community.",
    p2: "Our focus remains on delivering excellence through meticulous planning and superior infrastructure, ensuring that every investment with us grows in value and lifestyle for generations to come.",
    name: "M.N. RAO",
    designation: "Chairman & MD",
    legacy: '"Your trust is our legacy"'
  },
  gallery: {
    badge: "Our Project Visuals",
    titlePart1: "Project",
    titlePart2: "Gallery",
    description: "Take a glimpse into the progress and beauty of Elite County."
  },
  faq: {
    badge: "Got Questions?",
    titlePart1: "Frequently Asked",
    titlePart2: "Questions",
    questions: [
      {
        question: "Is the land legally approved?",
        answer: "Yes, all our plots in Elite County are 100% legally approved with clear titles and required permissions from local authorities."
      },
      {
        question: "What are the plot sizes available?",
        answer: "We offer a variety of premium villa plot sizes starting from 150 sq. yards to 400 sq. yards, catering to different requirements."
      },
      {
        question: "How far is the project from the Regional Ring Road (RRR)?",
        answer: "Elite County is strategically located within very close proximity to the proposed Regional Ring Road, ensuring high future appreciation."
      },
      {
        question: "Are bank loans available for the plots?",
        answer: "Yes, we have tie-ups with leading banks to provide easy financing and loan facilities for our customers."
      }
    ],
    footerTitle: "Still have questions?",
    footerSubtitle: "Our experts are here to help you make the right investment decision.",
    footerCta: "Contact Support"
  },
  contact: {
    badge: "Get In Touch",
    titlePart1: "Schedule Your",
    titlePart2: "Site Visit",
    titlePart3: "Today",
    description: "Our team is ready to assist you in making the best real estate investment. Reach out to us for a personalized consultation.",
    officeTitle: "Visit Our Office",
    callTitle: "Call Us Directly",
    callHours: "Mon-Sun: 9:00 AM - 7:00 PM",
    emailTitle: "Send Us An Email",
    emailResponse: "We'll respond within 24 hours.",
    formLabels: {
      fullName: "Full Name",
      phone: "Phone Number",
      email: "Email Address (Optional)",
      time: "Preferred Time for Visit",
      message: "Message"
    },
    formPlaceholders: {
      fullName: "Enter your name",
      phone: "Enter phone number",
      email: "Enter your email",
      message: "Tell us about your requirements..."
    },
    timeOptions: [
      "Morning (9 AM - 12 PM)",
      "Afternoon (12 PM - 4 PM)",
      "Evening (4 PM - 7 PM)"
    ],
    ctaButton: "Send Request"
  },
  footer: {
    aboutText: "Building trust and creating landmarks that redefine luxury living. Your partner in premium real estate investments since 2010.",
    quickLinks: "Quick Links",
    properties: "Properties",
    contactInfo: "Contact info",
    propertyList: [
      "Elite County",
      "Luxury Villa Plots",
      "Residential Lands",
      "Future Investment"
    ],
    copyright: "© 2026 Abhayasri Infra Developers. All rights reserved.",
    privacy: "Privacy Policy",
    terms: "Terms & Conditions"
  }
};
